module.exports = __webpack_public_path__ + "img/feature-tile-icon-09.086ce2ea.svg";